import React from 'react'
import {
  firstNameField,
  middleNameField,
  lastNameField,
  suffixField
} from '../../../fields/name'
import { Divider } from '../../../components/divider'
import { awardsField } from '../../../fields/award'
import { workEmailField } from '../../../fields/contact'
import {
  jobTitleField,
  workPhoneField,
  workPhone2Field
} from '../../../fields/employment'
import {
  complaintTypeField,
  multilineField,
  fileField
} from '../../../fields/complaint'
import { hhsProgramsField } from '../../../fields/hhsProgram'
import { reviewOpDivPage, subjectNoRelationPage } from '../../../pages'
import { InspectOpDiv } from '../../../components/Inspect'
import { complaintType } from '../../../choices'

import { validationSchema } from './validationSchema'
const complaintTypeChoices = complaintType().filter(
  choice =>
    ![
      'agent_import_permit_fraud',
      'medical_identity_theft',
      'whistleblower_retaliation'
    ].includes(choice.value)
)

export const formSchema = (onSubmit, setFocusName) => ({
  onSubmit,
  pages: [
    {
      id: 'opdiv_referral',
      validation: validationSchema,
      fields: [
        {
          ...hhsProgramsField,
          label: 'Operating division',
          labelClassName: 'ds-u-font-size--h2',
          errorMessageClassName: 'ds-u-font-size--base'
        },
        {
          type: 'content',
          component: () => 
              <Divider id="poc" />
        },
        {
          type: 'content',
          component: () => <h2>Point of contact</h2>
        },
        {
          type: 'radio',
          name: 'poc_reporting',
          choices: [
            { label: `Yes, I'm the POC`, value: 'Yes' },
            { label: `No, I'll provide POC`, value: 'No' }
          ],
          label: 'Are you the point of contact (POC) for this investigation?'
        },
        firstNameField,
        middleNameField,
        lastNameField,
        suffixField,
        jobTitleField,
        {
          type: 'content',
          component: () => (
            <React.Fragment>
              <Divider />
              <h2>Point of contact work contact information</h2>
              <p>Work email and at least one phone number are required</p>
            </React.Fragment>
          )
        },
        {
          ...workEmailField,
          labelClassName: 'ds-u-margin-top--0'
        },
        {
          ...workPhoneField,
          label: 'Office phone'
        },
        {
          ...workPhone2Field,
          label: 'Work cell phone'
        },
        {
          type: 'content',
          component: () => <Divider id="complaint" />
        },
        {
          ...complaintTypeField,
          type: 'select',
          choices: [{ label: '', value: '' }, ...complaintTypeChoices],
          conditionals: [
            {
              value: 'grant_contract_fraud',
              fields: [
                {
                  ...awardsField,
                  labelClassName: 'ds-u-font-size--h2',
                  max: 10
                }
              ]
            }
          ]
        },
        {
          ...multilineField,
          name: 'narrative',
          label: 'Complaint details',
          hint: 'Please provide a summary description of the allegation'
        },
        {
          type: 'content',
          component: () => <Divider id="attachments" />
        },
        {
          ...fileField,
          label: 'Attachments',
          hint: 'Please attach supporting documentation here.'
        },
        {
          type: 'content',
          component: () => (
            <p>
              If, for any reason, you are unable to attach files at this time,
              please list any documents you may have to support the
              allegation(s) in the box below.
            </p>
          )
        },
        {
          ...multilineField,
          name: 'evidence_description',
          label: 'Additional supporting documentation'
        },
        {
          type: 'content',
          component: () => <Divider id="subjects" />
        }
      ],
      action: {
        buttonText: 'Continue to add subjects'
      }
    },
    subjectNoRelationPage(),
    subjectNoRelationPage({ index: 1 }),
    subjectNoRelationPage({ index: 2 }),
    subjectNoRelationPage({ index: 3 }),
    subjectNoRelationPage({ index: 4 }),
    subjectNoRelationPage({ index: 5 }),
    subjectNoRelationPage({ index: 6 }),
    subjectNoRelationPage({ index: 7 }),
    subjectNoRelationPage({ index: 8 }),
    subjectNoRelationPage({ index: 9 }),
    reviewOpDivPage(props => (
      <InspectOpDiv setFocusName={setFocusName} {...props} />
    ))
  ]
})
